import React from "react"
import {Box, Button, Link, Stack, Typography} from "@mui/material";
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import {bytesToSize, generateDownloadUrl} from "../../utility/navigationUtil";
import {metaDataProperty} from "../preview/previewMetaData";
import {usePreviewContext} from "../../context/PreviewContext";
import {getDataType} from "../../utility/componentUtil";
import styles from "../../common/constants/accessibility.module.css";

interface Props {
    download: any[],
    propertyName?: string,
    downloadTitle?: string | null
    hideSize?: boolean
    isHovered?: boolean
    noLink?: boolean
    showDocumentTitle?: boolean
    target?: string
    tabIndex?: number
}

function CCODownloadButton(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const iconBoxStyle = {
        height: '40px',
        width: '40px',
        padding: '10px',
        borderRadius: '50%',
        transition: 'background-color 1s ease-out',
        backgroundColor: props.isHovered ? 'primary.dark' : "primary.main"
    }
    const titleStyle = {
        textDecoration: 'none!important',
        transition: 'color 1s ease-out',
        color: props.isHovered ? "primary.main" : 'text.primary'
    }
    const flexStyle = {display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}
    const target = props.target || '_blank';

    return props.download[0] && <Button
        tabIndex={props.tabIndex}
        className={styles.focusable}
        data-cypress={'downloadButtonComponent'}
        component={props.noLink ? 'div' : Link}
        href={props.noLink ? undefined : generateDownloadUrl(
            props.download[0]!.id ?? '',
            props.downloadTitle ?? props.download[0]!.title ?? ''
        )}
        target={target}
        sx={{
            "&.MuiButtonBase-root:hover": {
                bgcolor: "transparent"
            },
            height: '70px'
        }}>
        <Stack direction="row" alignItems="center" gap={2}>
            <Box sx={iconBoxStyle}> <DownloadRoundedIcon data-cypress={'downloadRoundedIcon'} fontSize={'small'} htmlColor={'white'}></DownloadRoundedIcon>
            </Box>
            <Box sx={flexStyle}>
                <Typography
                    sx={titleStyle} {...metaDataProperty(isPreview, props.propertyName)}>{props.showDocumentTitle ? props.downloadTitle || 'Download' : 'Download'}</Typography>
                {props.download[0]  && props.download[0].data?.contentType ? <Typography color={'#000'} variant={'subtitle2'}>
                    ({getDataType(props.download[0].data?.contentType)}{props.hideSize ? '' :
                    ' ' + bytesToSize(props.download[0]!.data?.size || 0).replace('.', ',')})
                </Typography> : ''}
            </Box>

        </Stack>
    </Button>
}

export default CCODownloadButton